import CodeIcon from "@mui/icons-material/Code"
import {IconButton} from "@mui/material"
import React from "react"
import {openTomBackoffice} from "../misc/utils"
import {useDevNodePicker} from "../misc/useDevNodePicker"

const BackofficeButton = () => {
    useDevNodePicker()

    if (window._env_.MODE !== "dev") return null

    return (
        <IconButton
            variant="contained"
            onClick={() => openTomBackoffice()}
            title="tOM-Backoffice öffnen (Alt+Klick springt zum Element)"
            style={{
                position: "fixed",
                top: "auto",
                bottom: "24px",
                right: "24px",
                zIndex: 9999,
                backgroundColor: "#072eca",
            }}
        >
            <CodeIcon sx={{color: "#ffffff"}} />
        </IconButton>
    )
}

export default BackofficeButton
